var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplyVcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.001,
    height: 30,
    viewBox: "0 0 30.001 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#959595;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28,30H2a2,2,0,0,1-2-2V24H2a1,1,0,1,0,0-2H0V19H2a1,1,0,1,0,0-2H0V14H2a1,1,0,0,0,0-2H0V9H2A1,1,0,0,0,2,7H0V2A2,2,0,0,1,2,0H28a2,2,0,0,1,2,2V28A2,2,0,0,1,28,30ZM12.336,16.349a.62.62,0,0,0-.121.012,5.374,5.374,0,0,0-3.743,2.327,4.634,4.634,0,0,0-.437.788.4.4,0,0,0,.019.356,7.547,7.547,0,0,0,.513.751,7.232,7.232,0,0,0,.874.976,11.435,11.435,0,0,0,.875.75,8.749,8.749,0,0,0,10.336,0,8.365,8.365,0,0,0,.874-.751,8.706,8.706,0,0,0,.874-.976,6.531,6.531,0,0,0,.513-.751.317.317,0,0,0,.057-.356,3.915,3.915,0,0,0-.437-.788,5.441,5.441,0,0,0-3.743-2.327c-.031,0-.062,0-.094,0a.772.772,0,0,0-.457.136,4.685,4.685,0,0,1-5.472,0A.739.739,0,0,0,12.336,16.349ZM15.5,7a4.3,4.3,0,1,0,4.3,4.3A4.3,4.3,0,0,0,15.5,7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyVcard);
export default __webpack_public_path__ + "static/media/reply-vcard.8896aeedf41e2ebfdd388e45b1af0545.svg";
export { ForwardRef as ReactComponent };